import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const check = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { check(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const signup = async (body) => {
    const { data } = await api.post("/auth/signup", body);
    setUser(data);
    return data;
  };

  const completeOnboarding = async (body) => {
    const { data } = await api.post("/auth/onboarding", body);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const switchOutlet = async (restaurantId) => {
    const { data } = await api.post("/org/switch", { restaurant_id: restaurantId });
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{
      user, loading, login, signup, completeOnboarding, logout, switchOutlet,
      restaurant: user && user.restaurant,
      isAdmin: user && user.role === "admin",
      isManager: user && (user.role === "admin" || user.role === "manager"),
      isWaiter: user && user.role === "waiter",
      isKitchen: user && user.role === "kitchen",
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
